import dayjs from 'dayjs';
import { formatPhoneNumber } from 'common/helpers';
import { IPatient } from 'entities/Patient/Patient.models';

export const patientDataToDetails = (patient: IPatient | null) => {
  const details: { [key: string]: any } = {
    gender: '',
    age: '',
    dob: '',
    language: '',
    phone: '',
  };

  if (patient) {
    details.gender = patient.gender;
    details.age = dayjs().diff(dayjs(patient.dob), 'year');
    details.dob = dayjs(patient.dob).format('MM/DD/YY');
    details.language = patient.language;
    details.phone = formatPhoneNumber(patient.phone);
  }

  return details;
};
